import { useLingui } from '@lingui/react/macro';

import InputSearch from '@/design_system/InputSearch';

export const InvoiceSearch = ({
  search,
  debouncedSetSearch,
}: {
  search: string;
  debouncedSetSearch: (value: string) => void;
}) => {
  const { t } = useLingui();

  return (
    <InputSearch
      placeholder={t({
        id: 'accounting.invoices.search.placeholder',
        message: 'Search invoice...',
      })}
      ariaLabel={t({
        id: 'accounting.invoices.search.placeholder',
        message: 'Search invoice...',
      })}
      style={{ flex: 1, minWidth: '250px', maxWidth: '400px' }}
      value={search}
      onChange={debouncedSetSearch}
      size="medium"
    />
  );
};
